export interface Option {
  label: string;
  id: number | string;
}

export const groupByBase = [
  { id: null, label: 'Time', key: 'dt' },
  { id: 'job_name', label: 'Job name' },
  { id: 'primary_recruiter', label: 'Primary recruiter' },
  { id: 'primary_hm', label: 'Primary hiring manager' },
  { id: 'appl_source', label: 'Source (on application)' },
  { id: 'department', label: 'Department' },
  // { id: 'appl_location', label: 'Location (on application)' },
  { id: 'rejection_type', label: 'Rejection type' },
  { id: 'rejection_reason', label: 'Rejection reason' },
  // { id: 'gender', label: 'Gender' },
  { id: 'rejected_by_type', label: 'Rejected by' },
  { id: 'bgv_risk_level', label: 'Fraud status' },
];

export const breakDownByBase = [
  { id: null, label: 'None' },
  { id: 'job_name', label: 'Job name' },
  { id: 'primary_recruiter', label: 'Primary recruiter' },
  { id: 'primary_hm', label: 'Primary hiring manager' },
  { id: 'appl_source', label: 'Source (on application)' },
  { id: 'department', label: 'Department' },
  // { id: 'appl_location', label: 'Location (on application)' },
  { id: 'rejection_type', label: 'Rejection type' },
  { id: 'rejection_reason', label: 'Rejection reason' },
  // { id: 'gender', label: 'Gender' },
  { id: 'rejected_by_type', label: 'Rejected by' },
  { id: 'bgv_risk_level', label: 'Fraud status' },
];

export const metrics = [
  { id: 'passthrough_rate', label: 'Passthrough rate' },
  { id: 'overall_rate', label: 'Overall rate' },
  { id: 'time_in_stage', label: 'Time in stage' },
  // { id: 'time_to_reach_stage', label: 'Time to Reach Stage' },
];

export const EMPTY_DATA: any[] = [];
export const EMPTY_STAGE_MAPPING: Record<string, unknown> = {};

export interface StaticStage {
  title: string;
  accessor: string;
  timeAccessor: string | null;
}

// Static stage structure used when there is no dynamic stage mapping.
export const STATIC_STAGES: StaticStage[] = [
  {
    title: 'Application review stages',
    accessor: 'application_review_total_count',
    timeAccessor: 'time_in_application_review',
  },
  {
    title: 'Interview stages',
    accessor: 'interviews_total_count',
    timeAccessor: 'time_in_interviews',
  },
  {
    title: 'Offer stages',
    accessor: 'offer_total_count',
    timeAccessor: 'time_in_offer',
  },
  {
    title: 'Hired stages',
    accessor: 'hired_total_count',
    timeAccessor: null,
  },
];

const REJECTED_BY_TYPE_MAP: Record<string, string> = {
  User: 'User',
  AtsAutoRejectionRule: 'Auto-rejection rule',
};

export const formatRejectedByTypeValue = (value: string) =>
  REJECTED_BY_TYPE_MAP[value] || value;

const BGV_RISK_LEVEL_MAP: Record<string, string> = {
  '0': 'Not evaluated',
  '-1': 'Failed',
  '1': 'No issues',
  '2': 'Inconclusive',
  '3': 'Suspicious',
};

export const formatBgvRiskLevel = (value: string) =>
  BGV_RISK_LEVEL_MAP[value] || value;

// Threshold colors shared by every passthrough/overall percentage cell.
export const getPercentageColor = (percentage: number) =>
  percentage > 50 ? '#00A91B' : percentage > 25 ? '#FF9900' : '#FF0000';
